import { DateTime } from 'luxon'
import { DefinedTime } from '../types'

// Returns a DateTime object representing the specified time on the same date and in the same zone as the provided DateTime
export const getTimeAsDateTimeFromDateTime = (
  time: DefinedTime,
  dateTime: DateTime,
) => {
  return DateTime.local(
    dateTime.year,
    dateTime.month,
    dateTime.day,
    time.hour,
    time.minute,
    { zone: dateTime.zone },
  )
}
